<!-- 会员制社交 -->
<template>
  <div class="warp">
    <div class="banner"></div>
    <div class="member">
      <div class="item1">
        <div class="title">
          <span>
            选择绿茶会员制社交电商
            <br />你也可以玩转这些热门模式
          </span>
          <p>会员制设计电商行业应用场景</p>
        </div>
        <ul class="list1">
          <li>
            <img src="../../assets/images/member02.png" />
            <span>未来集市</span>
            <p>综合型分销商城，以裂变分销及会员机制快速积累流量</p>
          </li>
          <li>
            <img src="../../assets/images/member03.png" />
            <span>有品有鱼</span>
            <p>依托小米生态链打造的会员制社交电商，将好货分享给好友获得奖励</p>
          </li>
          <li>
            <img src="../../assets/images/member04.png" />
            <span>环球捕手</span>
            <p>社交+美食生活电商平台，基于社群的口碑裂变和自传播性分享好货</p>
          </li>
          <li>
            <img src="../../assets/images/member05.png" />
            <span>云集</span>
            <p>架构在S2b2c模式下，以会员制度配合社交方式的自营直销电商</p>
          </li>
          <li>
            <img src="../../assets/images/member06.png" />
            <span>每日一淘</span>
            <p>专业精选的会员制社交电商，让消费者自购省钱，分享赚钱</p>
          </li>
          <li>
            <img src="../../assets/images/member07.png" />
            <span>贝店</span>
            <p>通过社交化分享传播，实现消费者、店主以及供应链的三方链接</p>
          </li>
        </ul>
      </div>

      <div class="item2">
        <div class="title">
          <span>会员制+分销裂变</span>
          <p>基于会员制及分销机制，社交分享快速裂变流量</p>
        </div>
        <ul class="list2">
          <li>
            <img src="../../assets/images/member08.png" />
            <span>会员门槛设置</span>
            <p>
              <b>•</b>邀请制度设置（邀请码）
            </p>
            <p>
              <b>•</b>购买礼包成为会员
            </p>
            <p>
              <b>•</b>赚取积分升级会员
            </p>
          </li>
          <li>
            <img src="../../assets/images/member09.png" />
            <span>多级分销机制</span>
            <p>
              <b>•</b>会员等级体系
            </p>
            <p>
              <b>•</b>晋级条件设定
            </p>
            <p>
              <b>•</b>等级权益设置
            </p>
          </li>
          <li>
            <img src="../../assets/images/member10.png" />
            <span>佣金规则更灵活</span>
            <p>
              <b>•</b>分销返佣比例可调
            </p>
            <p>
              <b>•</b>自定会员晋级奖励
            </p>
            <p>
              <b>•</b>拉新培训津贴设置
            </p>
          </li>
          <li>
            <img src="../../assets/images/member11.png" />
            <span>快速推广宣传</span>
            <p>
              <b>•</b>快速生成宣传海报
            </p>
            <p>
              <b>•</b>一键获取宣传素材
            </p>
            <p>
              <b>•</b>专属推广二维码
            </p>
          </li>
        </ul>
      </div>

      <div class="item3">
        <div class="title">
          <span>多端口展示，渠道数据互通</span>
          <p>支持多个主流平台，全渠道覆盖汇聚更多流量</p>
        </div>
        <ul class="list3">
          <li>
            <img src="../../assets/images/member12.png" />
            <span>管理后台PC端</span>
          </li>
          <li>
            <img src="../../assets/images/member13.png" />
            <span>APP</span>
          </li>
          <li>
            <img src="../../assets/images/member14.png" />
            <span>分销OA端（H5）</span>
          </li>
          <li>
            <img src="../../assets/images/member15.png" />
            <span>微信小程序</span>
          </li>
          <li>
            <img src="../../assets/images/member16.png" />
            <span>抖音小程序</span>
          </li>
          <li>
            <img src="../../assets/images/member17.png" />
            <span>头条小程序</span>
          </li>
        </ul>
      </div>

      <div class="item4">
        <div class="title">
          <span>
            五大功能模块
            <br />打造优质设计电商平台
          </span>
        </div>
        <swiper :options="swiperOption" ref="mySwiper" style="padding-bottom: 1.4rem;">
          <!-- slides -->
          <swiper-slide>
            <div class="list4">
              <div class="top">
                <img src="../../assets/images/member18.jpg" />
              </div>
              <h3>分销管理</h3>
              <h4>
                <img src="../../assets/images/member25.png" />裂变分销体系管理，助力实现低成本拓客，多层级流量共享，引爆品牌裂变式扩张
                <img src="../../assets/images/member26.png" />
              </h4>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="list4">
              <div class="top">
                <img src="../../assets/images/member19.jpg" />
              </div>
              <h3>营销应用</h3>
              <h4>
                <img src="../../assets/images/member25.png" />借助丰富的营销应用，实现用户活跃度及复购率的增长，迅速裂变并聚集多元化消费需求
                <img src="../../assets/images/member26.png" />
              </h4>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="list4">
              <div class="top">
                <img src="../../assets/images/member20.jpg" />
              </div>
              <h3>运营管理</h3>
              <h4>
                <img src="../../assets/images/member25.png" />完善的后台管理功能，高效管理商城各项数据，为商城运营保驾护航
                <img src="../../assets/images/member26.png" />
              </h4>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="list4">
              <div class="top">
                <img src="../../assets/images/member21.jpg" />
              </div>
              <h3>交易管理</h3>
              <h4>
                <img src="../../assets/images/member25.png" />订单数据实时监控，每笔交易都有迹可循，大数据管控体系汇聚千万用户的真实消费情况
                <img src="../../assets/images/member26.png" />
              </h4>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="list4">
              <div class="top">
                <img src="../../assets/images/member22.jpg" />
              </div>
              <h3>客户CRM管理</h3>
              <h4>
                <img src="../../assets/images/member25.png" />根据用户消费特点进行标签分类，实现精细化运营，全面提升销售全流程工作效率
                <img src="../../assets/images/member26.png" />
              </h4>
            </div>
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
      <div class="item3" style="padding:.1rem 0 0">
        <div class="title">
          <span>丰富的营销玩法，引爆社交红利</span>
          <p>实现店铺高活跃、高客单、高复购，向乏味的营销方式说再见</p>
        </div>
        <img src="../../assets/images/member24.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "memberContact",

  data() {
    return {
      swiperOption: {
        // 参数选项,显示小点
        pagination: ".swiper-pagination",
        //循环
        loop: true,
        speed: 500, //匀速时间
        //每张播放时长3秒，自动播放
        autoplay: {
          delay: 3000
        },
        //滑动速度
        speed: 1000,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // delay:1000
      }
    };
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/member01.jpg") no-repeat left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
  }
  .member {
    .title {
      text-align: center;

      span {
        font-size: 0.48rem;
        font-weight: 500;
        line-height: 0.6rem;
        padding: 0.2rem 0;
        display: block;
      }
      p {
        font-size: 0.34rem;
        color: #888;
      }
    }
    .item1 {
      background-color: #fff8f0;
      padding: 0.6rem 0.4rem 1.2rem;
      .list1 {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 40%;
          background-color: #fff;
          box-shadow: 0px 3px 18px 0px rgba(221, 196, 42, 0.24);
          margin: 0 5%;
          margin-top: 0.8rem;
          border-radius: 0.2rem;
          padding: 0.4rem;
          img {
            width: 1.2rem;
            height: 1.2rem;
            display: block;
            margin: auto;
          }
          span {
            display: block;
            text-align: center;
            font-size: 0.4rem;
            padding-top: 0.3rem;
            color: #000;
            font-weight: 500;
          }
          p {
            font-size: 0.32rem;
            color: #888;
            padding-top: 0.1rem;
            line-height: 0.55rem;
          }
        }
      }
    }
    .item2 {
      background-color: #fbf4eb;
      padding: 0.8rem 0.5rem;
      .list2 {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 50%;
          padding: 0.8rem 0 0.2rem;
          img {
            width: 100%;
          }
          span {
            font-size: 0.4rem;
            color: #000;
            font-weight: 500;
            padding-left: 1.1rem;
            padding-bottom: 0.15rem;
            display: block;
          }
          p {
            padding-left: 1.1rem;
            color: #888888;
            font-size: 0.32rem;
            line-height: 0.5rem;
            b {
              padding-right: 0.05rem;
              font-weight: 900;
            }
          }
        }
      }
    }
    .item3 {
      padding: 1rem 0;
      .list3 {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 33.3333%;
          text-align: center;
          padding-top: 0.6rem;
          img {
            width: 2.2rem;
            height: 2.2rem;
          }
          span {
            font-size: 0.34rem;
            display: block;
            padding: 0.2rem 0;
          }
        }
      }
    }
    .item4 {
      padding-bottom: 1rem;
      .list4 {
        .top {
          img {
            width: 100%;
          }
        }
        h3 {
          font-size: 0.42rem;
          font-weight: 500;
          padding: 0.1rem 0;
          padding-left: 1.6rem;
        }
        h4 {
          font-weight: 400;
          padding: 0 1.6rem;
          text-indent: -0.55rem;
          font-size: 0.34rem;
          color: #666;
          line-height: 0.55rem;
          img {
            width: 0.55rem;
          }
        }
      }

      .swiper-button-prev {
        left: 80%;
        width: 1rem;
        height: 1rem;
        background: url("../../assets/images/member23.png") no-repeat center
          center #ecedf0;
        background-size: 0.5rem;
        border-radius: 1rem;
        left: inherit;
        right: 3rem;
        top: inherit;
        bottom: 0;
      }
      .swiper-button-next {
        width: 1rem;
        height: 1rem;
        background: url("../../assets/images/member23.png") no-repeat center
          center #ecedf0;
        background-size: 0.5rem;
        border-radius: 1rem;
        transform: rotate(180deg);
        right: 1.6rem;
        top: inherit;
        bottom: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/memberContact.vue